var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"meeting-status",class:`meeting-status--${_vm.status}`},[(_vm.spinning)?_c('i',{staticClass:"fas fa-circle-notch fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }